export function convertDMtoDD(
  degrees: number | string,
  minutes: number | string,
  direction: string
): number {

  const deg = Number(degrees);
  const min = Number(minutes);

  let dd = deg + min / 60;

  if (direction === 'S' || direction === 'W') {
    dd = dd * -1;
  }

  return Number(dd.toFixed(6));
}

export function convertLatitudeDDtoDM(dd: number): string {
  const degrees = Math.floor(Math.abs(dd));
  const minutes = (Math.abs(dd) - degrees) * 60;
  const direction = dd >= 0 ? 'N' : 'S';
  return `${degrees}° ${minutes.toFixed(2)}' ${direction}`;
}

export function convertLongitudeDDtoDM(dd: number): string {
  const degrees = Math.floor(Math.abs(dd));
  const minutes = (Math.abs(dd) - degrees) * 60;
  const direction = dd >= 0 ? 'E' : 'W';
  return `${degrees}° ${minutes.toFixed(2)}' ${direction}`;
}
